import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import transactionSummaryTemplate from './transactionSummary.template.html';

export default angular
  .module('books.ui.transactionSummary', [csmCommonWeb, booksService])
  .directive('transactionSummary', transactionSummaryDirective).name;

/* @ngInject */
function transactionSummaryDirective(BooksSvc, BusyScreen) {
  return {
    template: transactionSummaryTemplate,
    scope: {
      acctSin: '@', // Label for type of report in singular format
      acctPl: '@', // Label for type of report in plural format
      reportByHide: '@', // Hides the "report by" div when true.
      groupByHide: '@' // Hides the "group by" div when true.
    },
    link: function ($scope, element, attr) {
      /*---------------------------------------------------------*/
      /* Sets the defaults of the report to be pulled by account */
      /* and account name and puts the report in PDF format.     */
      /*---------------------------------------------------------*/
      $scope.req = {
        reportByGroup: false,
        order: 'NAME',
        reportFormat: 'PDF',
        groupID: -1
      };
      $scope.data = {};

      /*-------------------------------------------------*/
      /* Validates the start and end dates are populated */
      /*-------------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*****************************************************************************
       * checkGroup */
      /**
       * Verifies the groupID entry. If -1 clears the text on blur.
       *****************************************************************************/
      $scope.checkGroup = function () {
        if ($scope.req.groupID == -1) {
          $scope.data.group = null;
        }
      };

      /*--------------------------------------------------*/
      /* Watches the data.group and sets the groupID to   */
      /* -1 (all groups) if an invalid selection was made */
      /*--------------------------------------------------*/
      $scope.$watch('data.group', function (group) {
        var groupSelected = group && angular.isObject(group);
        $scope.req.groupID = groupSelected ? group.id : -1;
      });

      var mGroups = [];
      var mAllOption = { id: 0, description: 'No Group' };

      /*--------------------------------------------------------*/
      /* Adds the mAllOption to the top of the groups typeahead */
      /*--------------------------------------------------------*/
      $scope.getGroups = function (text) {
        return [mAllOption].concat(
          mGroups.filter(function (g) {
            return g.description.toLowerCase().indexOf(text.toLowerCase()) > -1;
          })
        );
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getAccountGroups().then(function (resp) {
        mGroups = resp.data.sort(function (a, b) {
          return a.description
            .toLowerCase()
            .localeCompare(b.description.toLowerCase());
        });

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
